import React from 'react';
import { Fade } from 'react-reveal';
import { SocialMedia } from '../socialmedia/SocialMedia';
import Button from '../buttons/Button';
import LaptopImg from './LaptopImg';
import { Link } from 'react-router-dom';
import './Greeting.css';

const Greeting = () => {
  return (
    <Fade bottom duration={2000} distance='40px'>
      <div className='greet-main'>
        <div className='greeting-main'>
          <div className='greeting-text-div'>
            <h1 className='greeting-text'>Ollivier Julles Morales</h1>
            <h2 className='greeting-nickname'>(Julles)</h2>
            <p className='greeting-text-p'>
              A passionate individual who constantly strives to become great and
              who believes that knowledge and experiences are what makes a
              person successful. An individual who is always eager to learn new
              things, and is willing to step out of his comfort zone at all
              times.
            </p>
            <SocialMedia />
            <div className='portfolio-repo-btn-div'>
              <Link to='/contact' style={{ textDecoration: 'none' }}>
                <Button text='📞 Contact Me' className='portfolio-repo-btn' />
              </Link>
            </div>
          </div>
          <div className='greeting-image-div'>
            <LaptopImg />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Greeting;
